module.exports = __webpack_public_path__ + "img/logo_main.8c9e2c84.svg";